import React, { Component } from 'react'
import { sidebarMenuItems } from "../../../../config/settingsMenu"
import { Link, withRouter } from 'react-router-dom'

// const SomeComponent = withRouter(props => <AppSettingsSidebarMenu {...props}/>);

class AppSettingsSidebarMenu extends Component {
	constructor( props ) {
		super(props);
	}
    render() {
        return (
        	<ul className="settings--sidebar-menu">
				{
					sidebarMenuItems.map((item, key) => (
						<li key={key} className={this.props.location.pathname === item.url ? 'active' : '' }>
							<Link to={item.url}><span>{item.title}</span></Link>
						</li>
					))
				}
			</ul>
        )
    }
}

export default withRouter(AppSettingsSidebarMenu)


// WEBPACK FOOTER //
// ./src/application/components/settings/parts/sidebarMenu.js